<div class="flex">
    <p-dialog
        [(visible)]="addNewDialog"
        header="New Funding Modification"
        [modal]="true"
    >
        <!-- <p-floatlabel class="w-full md:w-56 mt-2" variant="on">
            <p-dropdown
                inputId="cn_label"
                styleClass="w-full"
                [options]="cnSelectItems"
                [(ngModel)]="newFundingMod.CNListID"
                (onChange)="addNewCNValueChanged($event)"
            >
            </p-dropdown>
            <label for="cn_label">Charge Number</label>
        </p-floatlabel> -->

        <div class="w-full md:w-56 mt-2">
            <p-dropdown
                inputId="cn_label"
                styleClass="w-full"
                [options]="cnSelectItems"
                [(ngModel)]="newFundingMod.CNListID"
                (onChange)="addNewCNValueChanged($event)"
                placeholder="Select a Charge Number"
            >
            </p-dropdown>
        </div>

        <p-floatlabel class="w-full md:w-56 mt-4" variant="on">
            <input
                inputId="modnbr"
                class="ef-dialog-control"
                type="text"
                pInputText
                id="modnbr"
                [(ngModel)]="newFundingMod.FundingModNbr"
                required
                style="width: 100%"
            />
            <label for="modnbr">Modification Number</label>
        </p-floatlabel>

        <p-floatlabel class="w-full md:w-56 mt-4" variant="on">
            <p-datepicker
                [style]="{ width: '100%' }"
                appendTo="body"
                [monthNavigator]="true"
                [yearNavigator]="true"
                yearRange="2010:2030"
                [(ngModel)]="newFundingMod.FundingModDate"
                (onSelect)="onFundingModDateSelected($event)"
                id="moddate"
                inputId="moddate"
                required
            >
            </p-datepicker>
            <label for="moddate">Modification Date</label>
        </p-floatlabel>

        <p-floatlabel class="w-full md:w-56 mt-4" variant="on">
            <input
                class="w-full"
                type="text"
                pInputText
                id="modamt"
                inputId="modamt"
                [(ngModel)]="newFundingMod.FundingModAmount"
                required
            />
            <label for="modamt">Modification Amount</label>
        </p-floatlabel>

        <p-floatlabel class="w-full md:w-56 mt-4" variant="on">
            <input
                class="w-full"
                type="text"
                pInputText
                id="hours"
                inputId="hours"
                [(ngModel)]="newFundingMod.AuthorizedHours"
                required
            />
            <label for="hours">Hours</label>
        </p-floatlabel>

        <p-floatlabel class="w-full md:w-56 mt-4" variant="on">
            <input
                class="w-full"
                type="text"
                pInputText
                id="modurl"
                inputId="modurl"
                [(ngModel)]="newFundingMod.FundingModURL"
            />
            <label for="modurl">Modification Doc URL</label>
        </p-floatlabel>

        <ng-template #footer>
            <button
                pButton
                label="Cancel"
                icon="pi pi-times"
                (click)="hideDialog()"
                class="p-button-text p-button-danger"
            ></button>
            <button
                pButton
                label="Save"
                icon="pi pi-check"
                class="p-button-text"
                (click)="saveNewMod()"
                class="p-button-text p-button-success"
            ></button>
        </ng-template>
    </p-dialog>
</div>

<div style="display: flex">
    <p-dialog
        header="Add Authorizations"
        [(visible)]="displayDatesDialog"
        [maximizable]="false"
        [closable]="false"
        [closeOnEscape]="false"
    >
        <div
            *ngIf="this.displayWarning == true"
            style="display: flex; justify-content: center"
        >
            <p-message
                severity="warn"
                text="Your end date must be a later date than your start date."
            ></p-message>
        </div>

        <h3>
            {{ this.activeUserAuthCount }} authorizations will be created for
            {{ this.rollingCNFullName }}
        </h3>

        <label style="font-size: 11px">Start Date:</label>
        <div style="margin-bottom: 1em">
            <p-datepicker
                appendTo="body"
                [monthNavigator]="true"
                [yearNavigator]="true"
                yearRange="2010:2030"
                [(ngModel)]="rollingAuthStartDate"
                (onSelect)="onAuthStartDateSelected($event)"
            >
            </p-datepicker>
        </div>

        <label style="font-size: 11px">End Date:</label>
        <div style="margin-bottom: 2em">
            <p-datepicker
                appendTo="body"
                [monthNavigator]="true"
                [yearNavigator]="true"
                yearRange="2010:2030"
                [(ngModel)]="rollingAuthEndDate"
                (onSelect)="onAuthEndDateSelected($event)"
            >
            </p-datepicker>
        </div>

        <!-- <div>
            <label
                >Note: Last time entered on {{ this.currentCNFullName }} is
                {{ this.maxTimeEntered }}</label
            >
        </div> -->

        <ng-template #footer >
            <button
                type="button"
                pButton
                icon="pi pi-check"
                (click)="confirmBtnClickedDateDialog()"
                class="p-button-text p-button-success"
                label="Confirm"
            ></button>
            <button
                type="button"
                pButton
                (click)="cancelBtnClickedDateDialog()"
                icon="pi pi-times"
                class="p-button-text p-button-danger"
                label="Cancel"
            ></button>
        </ng-template>
    </p-dialog>
</div>

<div class="card">
    <p-accordion
        #contractAccordion
        styleClass="contract-accordion"
        multiple="true"
        (activeIndexChange)="handleOnOpen($event)"
    >
        <p-accordionTab
            header="Contract"
            [(selected)]="activeState[0]"
            style="width: 100%"
        >
            <div class="accordion-panel-content" [ngStyle]="{ height: cTabHeight }">
                <div class="flex items-center">
                    <p-checkbox
                        inputId="inactivec"
                        #chkShowAllContracts
                        binary="true"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Include Inactive Contracts"
                        (onChange)="showAllContractsChecked($event)"
                        [(ngModel)]="cCbxValue"
                    ></p-checkbox>
                    <label for="inactivec" class="ml-2"> Include Inactive Contracts </label>
                </div>

                <div class="contract table-panel">
                    <p-table stripedRows #dataTable
                        [value]="this.contracts"
                        [(selection)]="this.selectedContract"
                        selectionMode="single"
                        (onRowSelect)="onContractSelected($event)"
                        [style]="{ width: '100%' }"
                        scrollHeight="flex"
                        [scrollable]="true"
                        editMode="row"
                        (onRowEditSave)="onContractRowEditSave($event)"
                        dataKey="ContractListID"
                    >
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="12" style="text-align: center">
                                    <div class="tabulator-placeholder">
                                        <span> No Data Available </span>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template #header>
                            <tr>
                                <th pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell"></th>
                                <th pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                                    <!-- <i
                                        class="pi pi-question-circle"
                                        style="font-size: 1.65rem"
                                        title="Status"
                                    ></i> -->
                                </th>
                                <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="ContractDesc">
                                    Contract
                                    <p-sortIcon
                                        field="ContractDesc"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                    <p-columnFilter field="ContractListID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                        <ng-template #filter let-value let-filter="filterCallback">
                                            <p-multiSelect
                                                class="filter"
                                                defaultLabel="Filter"
                                                [options]="contractsSelectItem"
                                                [filter]="true"
                                                appendTo="body"
                                                styleClass="w-full"
                                                [ngModel]="value"
                                                (ngModelChange)="filter($event)"
                                            >
                                            </p-multiSelect>
                                        </ng-template>
                                    </p-columnFilter>
                                    <!-- <button
                                        *ngIf="this.cEditing"
                                        pButton
                                        pRipple
                                        class="p-button-secondary"
                                        type="button"
                                        icon="pi pi-lock"
                                        text
                                        rounded
                                        (click)="IsContractLocked = !IsContractLocked"
                                    >
                                    </button> -->
                                </th>
                                <th *ngIf="this.cCbxValue == true">
                                    <i
                                        class="pi pi-ban"
                                        style="font-size: 1.65em"
                                        title="Inactive"
                                    ></i>
                                </th>
                                <th pSortableColumn="ContractCategory">
                                    Category
                                    <p-sortIcon
                                        field="ContractCategory"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                    <p-columnFilter field="ContractCategory" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                        <ng-template #filter let-value let-filter="filterCallback">
                                            <p-multiSelect
                                                class="filter"
                                                defaultLabel="Filter"
                                                [options]="catSelectItem"
                                                [filter]="true"
                                                appendTo="body"
                                                styleClass="w-full"
                                                [ngModel]="value"
                                                (ngModelChange)="filter($event)"
                                            >
                                            </p-multiSelect>
                                        </ng-template>
                                    </p-columnFilter>
                                    <!-- <button
                                        pButton
                                        pRipple
                                        class="p-button-secondary"
                                        [icon]="categoryLockIcon"
                                        rounded
                                        text
                                        *ngIf="this.cEditing"
                                        (click)="toggleLockCategoryColumn(false, $event)"
                                    >
                                    </button> -->
                                </th>
                                <th pSortableColumn="IsSCA">
                                    SCA
                                    <p-sortIcon
                                        field="IsSCA"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                </th>
                                <th pSortableColumn="ContractValue">
                                    Contract Value
                                    <p-sortIcon
                                        field="ContractValue"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                </th>
                                <th pSortableColumn="ContractFunding">
                                    Funded Amount
                                    <p-sortIcon
                                        field="ContractFunding"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                </th>
                                <th pSortableColumn="ContractStartDate">
                                    Start Date
                                    <p-sortIcon
                                        field="ContractStartDate"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                </th>
                                <th pSortableColumn="ContractEndDate">
                                    End Date
                                    <p-sortIcon
                                        field="ContractEndDate"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                </th>
                                <th pSortableColumn="PrimeContractNo">
                                    Prime Number
                                    <p-sortIcon
                                        field="PrimeContractNo"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                </th>
                                <th pSortableColumn="SubContractNo">
                                    Sub Number
                                    <p-sortIcon
                                        field="SubContractNo"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                </th>
                                <th pSortableColumn="OrderNumber">
                                    Order Number
                                    <p-sortIcon
                                        field="OrderNumber"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                </th>
                                <th>
                                    Contract Warning
                                </th>
                                <th>
                                    Funding Warning
                                </th>
                                <th>
                                    Fee Warning
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template
                            #body
                            let-contract
                            let-editing="editing"
                            let-ri="rowIndex"
                        >
                            <tr
                                [pEditableRow]="contract"
                                [pSelectableRow]="contract"
                                data-id="row-{{ contract.ContractListID }}"
                            >
                                <td pFrozenColumn  [frozen]="IsColumnFrozen" class="edit-cell">
                                    @if (
                                        !editing &&
                                        (!cEditing?.ContractListID ||
                                            cEditing?.ContractListID === contract?.ContractListID) &&
                                        contract.IsActive == true
                                    ) {
                                        <button
                                            pButton
                                            pRipple
                                            type="button"
                                            pInitEditableRow
                                            icon="pi pi-pencil"
                                            (click)="onContractRowEditInit(contract)"
                                            rounded
                                            text
                                            title="Edit"
                                        ></button>
                                    }
                                    @else if (editing) {
                                        <button
                                            pButton
                                            pRipple
                                            type="button"
                                            pSaveEditableRow
                                            icon="pi pi-check"
                                            (click)="onContractRowEditSave(contract)"
                                            class="p-button-rounded p-button-text p-button-success"
                                            style="margin-right: 0.5em;"
                                        ></button>
                                        <button
                                            pButton
                                            pRipple
                                            type="button"
                                            pCancelEditableRow
                                            icon="pi pi-times"
                                            (click)="onContractRowEditCancel(contract, ri)"
                                            class="p-button-rounded p-button-text p-button-danger"
                                        ></button>
                                    }
                                </td>
                                <td
                                    pFrozenColumn
                                    [frozen]="IsColumnFrozen"
                                    (click)="statusCellClicked()"
                                    (mousedown)="$event.stopPropagation()"
                                    class="status-cell"
                                >
                                    <div (click)="onStatusClick(contract)" (mousedown)="$event.stopPropagation()">
                                        <ef-status-icon
                                            [status]="
                                                contract?.Status?.StatusCode
                                            "
                                            [message]="
                                                contract?.Status?.Message
                                            "
                                        ></ef-status-icon>
                                    </div>
                                </td>
                                <td pFrozenColumn [frozen]="IsColumnFrozen">
                                    <label [title]="contract.ContractDesc">{{
                                        contract.ContractDesc
                                    }}</label>
                                </td>
                                <td *ngIf="this.cCbxValue == true">
                                    <i
                                        *ngIf="contract.IsActive == false"
                                        class="pi pi-times skinny-icon"
                                        style="
                                            font-size: 1.65em;
                                            color: black;
                                            font-weight: normal;
                                        "
                                        title="Inactive"
                                    ></i>
                                </td>
                                <td>
                                    {{ contract.ContractCategory }}
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <p-checkbox
                                                binary="true"
                                                [(ngModel)]="
                                                    contract.IsSCA
                                                "
                                            ></p-checkbox>
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <i
                                                *ngIf="contract.IsSCA == true"
                                                class="pi pi-check"
                                                style="
                                                    font-size: 1.65em;
                                                    color: black;
                                                    font-weight: normal;
                                                "
                                                title="SCA"
                                            ></i>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="
                                                    contract.ContractValue
                                                "
                                            />
                                        </ng-template>
                                        <ng-template #output>
                                            {{
                                                currencyFormatter.format(
                                                    +contract.ContractValue
                                                )
                                            }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    {{
                                        currencyFormatter.format(
                                            +contract.ContractFunding
                                        )
                                    }}
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <p-datepicker
                                                [maxDate]="
                                                    contract.ContractEndDate
                                                "
                                                appendTo="body"
                                                [monthNavigator]="true"
                                                [yearNavigator]="true"
                                                yearRange="2010:2030"
                                                [(ngModel)]="
                                                    contract.ContractStartDate
                                                "
                                                (onSelect)="
                                                    onContractStartDateSelected(
                                                        $event
                                                    )
                                                "
                                            ></p-datepicker>
                                        </ng-template>
                                        <ng-template #output>
                                            <span
                                                *ngIf="
                                                    contract.ContractStartDate !=
                                                    null
                                                "
                                            >
                                                {{
                                                    moment(
                                                        contract.ContractStartDate
                                                    ).format('MM/DD/YYYY')
                                                }}
                                            </span>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td [title]="endDateTooltip">
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <p-datepicker
                                                [class.ng-invalid]="lessThanToday(contract.ContractEndDate)"
                                                appendTo="body"
                                                [minDate]="
                                                    contract.ContractStartDate
                                                "
                                                [monthNavigator]="true"
                                                [yearNavigator]="true"
                                                yearRange="2010:2030"
                                                [(ngModel)]="
                                                    contract.ContractEndDate
                                                "
                                                (onSelect)="
                                                    onContractEndDateSelected(
                                                        $event,
                                                        contract
                                                    )
                                                "
                                            ></p-datepicker>
                                        </ng-template>
                                        <ng-template #output>
                                            <span
                                                *ngIf="
                                                    contract.ContractEndDate !=
                                                    null
                                                "
                                            >
                                                {{
                                                    moment(
                                                        contract.ContractEndDate
                                                    ).format('MM/DD/YYYY')
                                                }}
                                            </span>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td [title]="contract.PrimeContractNo">
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="
                                                    contract.PrimeContractNo
                                                "
                                            />
                                        </ng-template>
                                        <ng-template #output>
                                            {{ contract.PrimeContractNo }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td [title]="contract.SubContractNo">
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="
                                                    contract.SubContractNo
                                                "
                                            />
                                        </ng-template>
                                        <ng-template #output>
                                            {{ contract.SubContractNo }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td [title]="contract.OrderNumber">
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="
                                                    contract.OrderNumber
                                                "
                                            />
                                        </ng-template>
                                        <ng-template #output>
                                            {{ contract.OrderNumber }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="
                                                    contract.ContractWarningLevel
                                                "
                                            />
                                        </ng-template>
                                        <ng-template #output>
                                            {{ contract.ContractWarningLevel }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="
                                                    contract.FundingWarningLevel
                                                "
                                            />
                                        </ng-template>
                                        <ng-template #output>
                                            {{ contract.FundingWarningLevel }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="
                                                    contract.FeeWarningLevel
                                                "
                                            />
                                        </ng-template>
                                        <ng-template #output>
                                            {{ contract.FeeWarningLevel }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </p-accordionTab>
        <p-accordionTab
            [header]="chargeNumberHeader"
            [(selected)]="activeState[1]"
            style="width: 100%"
            (selectedChange)="onSelectedChargeNumberTab($event)"
        >
            <div class="accordion-panel-content" [ngStyle]="{ height: cnTabHeight }">
                <div class="flex items-center">
                    <p-checkbox
                        inputId="inactivecn"
                        #chkShowAllContracts
                        class="ef-checkbox"
                        binary="true"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Include Inactive Charge Numbers"
                        (onChange)="showAllCNsChecked($event)"
                        [(ngModel)]="cnCbxValue"
                    ></p-checkbox>
                    <label for="inactivecn" class="ml-2"> Include Inactive Charge Numbers </label>
                </div>

                <div class="chargenumber table-panel">
                    <p-table stripedRows #CNTable
                        [value]="this.chargeNumbers"
                        dataKey="CNListID"
                        [rowTrackBy]="trackByChargeNumberRow"
                        [style]="{ width: '100%' }"
                        scrollHeight="flex"
                        [scrollable]="true"
                        editMode="row"
                        (onRowEditSave)="onRowEditSave($event)"
                    >
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="9" style="text-align: center">
                                    <div class="tabulator-placeholder">
                                        <span> No Data Available </span>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template #header>
                            <tr>
                                <th pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell"></th>
                                <th pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                                    <!-- <i
                                        class="pi pi-question-circle"
                                        style="font-size: 1.65em"
                                        title="Status"
                                    ></i> -->
                                </th>
                                <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="FullName">
                                    Charge Number
                                    <p-sortIcon
                                        field="FullName"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                    <p-columnFilter type="text" matchMode="contains" field="FullName" display="menu" class="ml-auto" />
                                </th>
                                <th *ngIf="this.cnCbxValue == true">
                                    <i
                                        class="pi pi-ban"
                                        style="font-size: 1.65em"
                                        title="Inactive"
                                    ></i>
                                </th>
                                <th pSortableColumn="ContractType">
                                    Type
                                    <p-columnFilter type="text" matchMode="contains" field="ContractType" display="menu" class="ml-auto" />
                                </th>
                                <th>
                                    Authorized Hours
                                </th>
                                <th>
                                    Funded Amount
                                </th>
                                <th>
                                    Funding Available
                                </th>
                                <th>
                                    Start Date
                                </th>
                                <th>
                                    End Date
                                </th>
                                <th>
                                    Line Item (CLIN)
                                </th>
                                <th>
                                    Funding Source (ACRN)
                                </th>
                                <th *ngIf="this.ccColumnHidden == false">
                                    Cost Center
                                </th>
                                <th>
                                    Service Center
                                </th>
                                <th>
                                    Service Center %
                                </th>
                                <th>
                                    Burn Rate Start
                                </th>
                                <th>
                                    Replacement Charge Number
                                </th>
                            </tr>
                        </ng-template>
                        <ng-template
                            #body
                            let-rowData
                            let-editing="editing"
                            let-ri="rowIndex"
                        >
                            <tr
                                [pEditableRow]="rowData"
                                data-id="row-{{ rowData.CNListID }}"
                            >
                                <td pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell">
                                    <button
                                        *ngIf="
                                            !editing &&
                                            (!cnEditing?.CNListID ||
                                                cnEditing?.CNListID ===
                                                    rowData?.CNListID) &&
                                            rowData.IsActive == true
                                        "
                                        pButton
                                        pRipple
                                        type="button"
                                        pInitEditableRow
                                        icon="pi pi-pencil"
                                        (click)="onRowEditInit(rowData)"
                                        class="p-button-rounded p-button-text"
                                        title="Edit"
                                    ></button>
                                    <button
                                        *ngIf="editing"
                                        pButton
                                        pRipple
                                        type="button"
                                        pSaveEditableRow
                                        icon="pi pi-check"
                                        (click)="onRowEditSave(rowData)"
                                        class="p-button-rounded p-button-text p-button-success"
                                        style="
                                            margin-right: 0.5em;
                                        "
                                    ></button>
                                    <button
                                        *ngIf="editing"
                                        pButton
                                        pRipple
                                        type="button"
                                        pCancelEditableRow
                                        icon="pi pi-times"
                                        (click)="onRowEditCancel(rowData)"
                                        class="p-button-rounded p-button-text p-button-danger"
                                    ></button>

                                </td>
                                <td pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                                    <div
                                        style="height: 2em; align-self: center"
                                    >
                                        <ef-status-icon
                                            [status]="
                                                rowData?.Status?.StatusCode
                                            "
                                            [message]="rowData?.Status?.Message"
                                        ></ef-status-icon>
                                    </div>
                                </td>
                                <td pFrozenColumn [frozen]="IsColumnFrozen">
                                    <label [title]="rowData.FullName">{{
                                        rowData.FullName
                                    }}</label>
                                </td>
                                <td *ngIf="this.cnCbxValue == true">
                                    <div *ngIf="rowData.IsActive == false">
                                        <i
                                            class="pi pi-times skinny-icon"
                                            style="
                                                font-size: 1.65em;
                                                color: black;
                                                font-weight: normal;
                                            "
                                            title="Inactive"
                                        ></i>
                                    </div>
                                </td>
                                <td>
                                    {{ rowData.ContractType }}
                                </td>
                                <td>
                                    {{ rowData.AuthorizedHours }}
                                </td>
                                <td>
                                    {{
                                        currencyFormatter.format(
                                            +rowData.FundedAmount
                                        )
                                    }}
                                </td>
                                <td>
                                    {{
                                        currencyFormatter.format(
                                            +rowData.FundingAvailable
                                        )
                                    }}
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <div>
                                                <p-datepicker
                                                    appendTo="body"
                                                    [monthNavigator]="true"
                                                    [yearNavigator]="true"
                                                    yearRange="2010:2030"
                                                    [(ngModel)]="
                                                        rowData.CNStartDate
                                                    "
                                                    (onSelect)="
                                                        onCNStartDateSelected(
                                                            $event
                                                        )
                                                    "
                                                ></p-datepicker>
                                            </div>
                                        </ng-template>
                                        <ng-template #output>
                                            <span
                                                *ngIf="
                                                    rowData.CNStartDate != null
                                                "
                                            >
                                                {{
                                                    moment(
                                                        rowData.CNStartDate
                                                    ).format('MM/DD/YYYY')
                                                }}
                                            </span>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <div>
                                                <p-datepicker
                                                    appendTo="body"
                                                    [monthNavigator]="true"
                                                    [yearNavigator]="true"
                                                    yearRange="2010:2030"
                                                    [(ngModel)]="
                                                        rowData.CNEndDate
                                                    "
                                                    (onSelect)="
                                                        onCNEndDateSelected(
                                                            $event
                                                        )
                                                    "
                                                ></p-datepicker>
                                            </div>
                                        </ng-template>
                                        <ng-template #output>
                                            <span
                                                *ngIf="
                                                    rowData.CNEndDate != null
                                                "
                                            >
                                                {{
                                                    moment(
                                                        rowData.CNEndDate
                                                    ).format('MM/DD/YYYY')
                                                }}
                                            </span>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="rowData.LineItem"
                                            />
                                        </ng-template>
                                        <ng-template #output>
                                            {{ rowData.LineItem }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="
                                                    rowData.FundingSourceCode
                                                "
                                            />
                                        </ng-template>
                                        <ng-template #output>
                                            {{ rowData.FundingSourceCode }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td *ngIf="this.ccColumnHidden == false">
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <div
                                                *ngIf="
                                                    userGroupSelectItems as items
                                                "
                                                class="text-nowrap-ellipsis"
                                            >
                                                <p-select
                                                    styleClass="w-full"
                                                    appendTo="body"
                                                    [options]="items"
                                                    [(ngModel)]="
                                                        rowData.CostCenterID
                                                    "
                                                    [virtualScroll]="true"
                                                    [virtualScrollItemSize]="
                                                        dropdownItemHeight
                                                    "
                                                    [filter]="false"
                                                    [autoDisplayFirst]="false"
                                                    (onChange)="
                                                        costCenterValueChanged(
                                                            $event
                                                        )
                                                    "
                                                >
                                                </p-select>
                                            </div>
                                        </ng-template>
                                        <ng-template #output>
                                            {{
                                                this.findCostCenterName(rowData)
                                            }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    {{ rowData.ServiceCenterListID }}
                                </td>
                                <td>
                                    {{ rowData.ServiceCenterPercent }}
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <div>
                                                <p-datepicker
                                                    appendTo="body"
                                                    [monthNavigator]="true"
                                                    [yearNavigator]="true"
                                                    yearRange="2010:2030"
                                                    [(ngModel)]="
                                                        rowData.BurnRateStartDate
                                                    "
                                                    (onSelect)="
                                                        onBurnStartDateSelected(
                                                            $event
                                                        )
                                                    "
                                                ></p-datepicker>
                                            </div>
                                        </ng-template>
                                        <ng-template #output>
                                            <span
                                                *ngIf="
                                                    rowData.BurnRateStartDate !=
                                                    null
                                                "
                                            >
                                                {{
                                                    moment(
                                                        rowData.BurnRateStartDate
                                                    ).format('MM/DD/YYYY')
                                                }}
                                            </span>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <div
                                                *ngIf="
                                                    replacementCNsSelectItem as items
                                                "
                                                class="text-nowrap-ellipsis"
                                            >
                                                <p-select
                                                    styleClass="w-full"
                                                    appendTo="body"
                                                    [options]="items"
                                                    [(ngModel)]="
                                                        rowData.RollingCNListID
                                                    "
                                                    [virtualScroll]="true"
                                                    [virtualScrollItemSize]="
                                                        dropdownItemHeight
                                                    "
                                                    [filter]="false"
                                                    [autoDisplayFirst]="
                                                        false
                                                    "
                                                >
                                                </p-select>
                                            </div>
                                        </ng-template>
                                        <ng-template #output>
                                            {{ this.findCNFullName(rowData) }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </p-accordionTab>
        <p-accordionTab
            [header]="fundingModHeader"
            [(selected)]="activeState[2]"
            style="width: 100%"
            (selectedChange)="onSelectedChargeNumberTab($event)"
        >
            <div class="accordion-panel-content" [ngStyle]="{ height: fmTabHeight }">
                <p-toolbar>
                    <div class="flex items-center">
                        <p-checkbox
                            inputId="currentYear"
                            binary="true"
                            [ngModel]="IsCurrentYearFM"
                            (onChange)="currentYearCheckboxChanged($event)"
                        ></p-checkbox>
                        <label for="currentYear" class="ml-2"> Show current year </label>
                    </div>
                    <button
                        pButton
                        icon="pi pi-plus-circle"
                        severity="primary"
                        (click)="openNew()"
                        label="New Funding Modification"
                    ></button>
                    <p-message
                        severity="info"
                        text="Change Funding Amounts by (1) entering a new funding mod or (2) updating the amount of an existing funding mod."
                    >
                    </p-message>
                </p-toolbar>
                <div class="fundingmod table-panel">
                    <p-table stripedRows id="FMTable"
                        #FMTable
                        [value]="this.fundingMods"
                        dataKey="FundingID"
                        [rowTrackBy]="trackByFundingModRow"
                        [style]="{ width: '100%' }"
                        scrollHeight="flex"
                        [scrollable]="true"
                        editMode="row"
                        (onRowEditSave)="onRowEditSave($event)"
                    >
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="6" style="text-align: left">
                                    <div class="tabulator-placeholder">
                                        <span> No Data Available </span>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template #header>
                            <tr>
                                <th pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell"></th>
                                <th pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                                    <!-- <i
                                        class="pi pi-question-circle"
                                        style="font-size: 1.65em"
                                        title="Status"
                                    ></i> -->
                                </th>
                                <th pSortableColumn="FullName" pFrozenColumn [frozen]="IsColumnFrozen">
                                    Charge Number
                                    <p-sortIcon
                                        field="FullName"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                    <p-columnFilter type="text" matchMode="contains" field="FillName" display="menu" class="ml-auto" />
                                </th>
                                <th pSortableColumn="FundingModNbr">
                                    Modification Number
                                    <p-sortIcon
                                        field="FundingModNbr"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                    <p-columnFilter type="text" matchMode="contains" field="FundingModNbr" display="menu" class="ml-auto" />
                                </th>
                                <th pSortableColumn="FundingModDate">
                                    Modification Date
                                    <p-sortIcon
                                        field="FundingModDate"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                    <p-columnFilter type="text" matchMode="contains" field="FundingModDate" display="menu" class="ml-auto" />
                                </th>
                                <th>
                                    Authorized Hours
                                </th>
                                <th>
                                    Modification Amount
                                </th>
                                <th>
                                    Modification Doc (URL)
                                </th>
                                <th pSortableColumn="DateUpdated">
                                    Date Updated
                                    <p-sortIcon
                                        field="DateUpdated"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                </th>
                                <th pSortableColumn="ModifiedBy">
                                    Modified By
                                    <p-sortIcon
                                        field="ModifiedBy"
                                        ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order"
                                    ></p-sortIcon>
                                </th>
                                <th></th>
                                <th hidden="true"></th>
                            </tr>
                        </ng-template>
                        <ng-template
                            #body
                            let-fm
                            let-editing="editing"
                            let-ri="rowIndex"
                        >
                            <tr
                                [pEditableRow]="fm"
                                data-id="row-{{ fm.FullName }}"
                            >
                                <td pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell">
                                    <button
                                        *ngIf="
                                            !editing &&
                                            (!fmEditing?.FundingID ||
                                                fmEditing?.FundingID ===
                                                    fm?.FundingID)
                                        "
                                        pButton
                                        pRipple
                                        type="button"
                                        pInitEditableRow
                                        icon="pi pi-pencil"
                                        (click)="onFMRowEditInit(fm)"
                                        class="p-button-rounded p-button-text"
                                        title="Edit"
                                    ></button>
                                    <button
                                        *ngIf="editing"
                                        pButton
                                        pRipple
                                        type="button"
                                        pSaveEditableRow
                                        icon="pi pi-check"
                                        (click)="onFMRowEditSave(fm)"
                                        class="p-button-rounded p-button-text p-button-success"
                                        style="
                                            margin-right: 0.5em;
                                        "
                                    ></button>
                                    <button
                                        *ngIf="editing"
                                        pButton
                                        pRipple
                                        type="button"
                                        pCancelEditableRow
                                        icon="pi pi-times"
                                        (click)="onFMRowEditCancel(fm, ri)"
                                        class="p-button-rounded p-button-text p-button-danger"
                                    ></button>
                                </td>
                                <td pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                                    <div
                                        style="height: 2em; align-self: center"
                                    >
                                        <ef-status-icon
                                            [status]="fm?.Status?.StatusCode"
                                            [message]="fm?.Status?.Message"
                                        ></ef-status-icon>
                                    </div>
                                </td>
                                <td pFrozenColumn [frozen]="IsColumnFrozen">
                                    <label [title]="fm.FullName">{{
                                        fm.FullName
                                    }}</label>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="fm.FundingModNbr"
                                            />
                                        </ng-template>
                                        <ng-template #output>
                                            {{ fm.FundingModNbr }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <div>
                                                <p-datepicker
                                                    appendTo="body"
                                                    [monthNavigator]="true"
                                                    [yearNavigator]="true"
                                                    yearRange="2010:2030"
                                                    [(ngModel)]="
                                                        fm.FundingModDate
                                                    "
                                                    (onSelect)="
                                                        onFundingModDateSelected(
                                                            $event
                                                        )
                                                    "
                                                ></p-datepicker>
                                            </div>
                                        </ng-template>
                                        <ng-template #output>
                                            <span
                                                *ngIf="
                                                    fm.FundingModDate != null
                                                "
                                            >
                                                {{
                                                    moment(
                                                        fm.FundingModDate
                                                    ).format('MM/DD/YYYY')
                                                }}
                                            </span>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="fm.AuthorizedHours"
                                            />
                                        </ng-template>
                                        <ng-template #output>
                                            {{ fm.AuthorizedHours }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="
                                                    fm.FundingModAmount
                                                "
                                            />
                                        </ng-template>
                                        <ng-template #output>
                                            {{
                                                currencyFormatter.format(
                                                    +fm.FundingModAmount
                                                )
                                            }}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    <p-cellEditor>
                                        <ng-template #input>
                                            <input
                                                pInputText
                                                type="text"
                                                [(ngModel)]="fm.FundingModURL"
                                            />
                                        </ng-template>
                                        <ng-template #output>
                                            <a *ngIf="fm.FundingModURL" [href]="fm.FundingModURL" target="_blank">{{ fm.FundingModURL }}</a>
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td>
                                    {{
                                        moment(fm.DateUpdated).format(
                                            'MM/DD/YYYY'
                                        )
                                    }}
                                </td>
                                <td>
                                    {{ fm.ModifiedBy }}
                                </td>
                                <td class="delete-cell">
                                    <button
                                        pButton
                                        type="button"
                                        class="btn btn-link"
                                        (click)="onFundingModDelete(fm)"
                                        icon="pi pi-trash"
                                        class="p-button-danger p-button-text"
                                    ></button>
                                    <!-- <a href="#" (click)="onFundingModDelete(fm)">Delete</a> -->
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </p-accordionTab>
    </p-accordion>

    <!-- <p-accordion styleClass="charge-number-accordion" (activeIndexChange)="handleOnOpen($event)">

    </p-accordion>

    <p-accordion styleClass="funding-accordion" (activeIndexChange)="handleOnOpen($event)">

    </p-accordion> -->
</div>
